export function urlParams(obj, prefix, shortBool = false) {
  if (obj instanceof FormData) {
    const temp = {};

    obj.forEach(function(value, key) {
      temp[key] = value;
    });

    obj = temp;
  }
  else if (!/^o/.test(typeof obj)) {
    return obj;
  }

  const str = [];
  for (const p in obj) {
    if (obj.hasOwnProperty(p) && obj[p] !== '') {
      const k = prefix ? prefix + '[]' : encodeURIComponent(p);
      const v = obj[p];
      if (typeof v === 'boolean' && shortBool) {
        if (v) {
					str.push(encodeURIComponent(k));
				}
      }
      else {
        str.push(typeof v === 'object' ? urlParams(v, prefix ? k : encodeURIComponent(k)) : k + '=' + encodeURIComponent(v));
      }
    }
  }
  return str.join('&');
}

export function getUrlParams(queryString) {
  const params = {};

  if (!(queryString = location.search.replace('?', ''))) {
    return params;
  }

  const queryParams = queryString.split('&');
  const regex = /\[\]$/;

  for (const param of queryParams) {
    let [name, value] = decodeURIComponent(param).split('=');
    value = value !== undefined ? value : true;
    if (regex.test(name)) {
      name = name.replace(regex, '');
      if (!Array.isArray(params[name])) {
        params[name] = [];
      }
      params[name] = [...params[name], value];
    }
    else {
      params[name] = value;
    }
  }

  return params;
}

export function makeUrl(params, baseUrl = `${location.origin}${location.pathname}`) {
  const urlParts = [
    baseUrl
  ];

  if (params) {
    params = urlParams(params, null, true);

    if (baseUrl.includes('?')) {
      urlParts.push('&');
    }
    else {
      urlParts.push('?');
    }

    urlParts.push(params);
  }

  return urlParts.join('');
}
